import _ from '../../../shared/utils/ObjectUtils';
import WidgetUtils from "../../utils/WidgetUtils";

export default {
    unZipInterfacesFromMultiInterfacesWidget(multipleInterfacesSelector) {
        let interfacesObj = JSON.parse(multipleInterfacesSelector).fieldLevel;
        let interfacesList = [];
        _.forOwn(interfacesObj, (obj, k) => {
            if(!_.isNil(obj.instInterface)) {
                interfacesList.push(obj.instInterface);
            }
            if(!_.isNil(obj.avgInterface)) {
                interfacesList.push(obj.avgInterface);
            }
        });

        return interfacesList;
    },

    getRealTimeInterfaces(widgetsConfigs) {
        const widgetsConfigsArray = Object.values(widgetsConfigs);
        let widgetsWithRealTimeInterfaceIdsArray = widgetsConfigsArray.filter(
            widget => {
                return widget.type === WidgetUtils.WidgetType.DIRECT_VALUE || widget.type === WidgetUtils.WidgetType.CONTROLLER;
            }
        );

        const realTimeInterfaceIds = widgetsWithRealTimeInterfaceIdsArray.reduce(
            (acc, widget) => {
                return [...acc, widget.configs.interfaceIds];
            },
            []
        );
        const uniqueRealTimeInterfaceIds = realTimeInterfaceIds.filter((v,i) => realTimeInterfaceIds.indexOf(v) === i);

        return uniqueRealTimeInterfaceIds;
    },

    getInterfacesIds(widgetsConfigs) {
        const widgetsConfigsArray = Object.values(widgetsConfigs);

        let interfaceIdsArray = widgetsConfigsArray.reduce(
            (acc, widget) => {
                switch (widget.type) {
                    case WidgetUtils.WidgetType.DIRECT_VALUE:
                    case WidgetUtils.WidgetType.CONTROLLER:
                        return [...acc, widget.configs.interfaceIds];
                    default:
                        return acc;
                }
            }, []
        );
        const uniqueInterfaceIds = interfaceIdsArray.filter((v,i) => interfaceIdsArray.indexOf(v) === i);

        return uniqueInterfaceIds;
    },
};